import { render, staticRenderFns } from "./ClientPortalDrawer.vue?vue&type=template&id=222db450&scoped=true&"
import script from "./ClientPortalDrawer.vue?vue&type=script&lang=js&"
export * from "./ClientPortalDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ClientPortalDrawer.vue?vue&type=style&index=0&id=222db450&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222db450",
  null
  
)

export default component.exports